<template>
  <el-dialog
    v-bind="$attrs"
    custom-class="base-dialog"
    :append-to-body="true"
    :visible.sync="isVisible"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="closeOnClickModal"
    :before-close="handleBeforeClose"
  >
    <div slot="title" class="dialog-header">
      <span>{{ $t('modal.close') }}</span>
      <img class="btn-close" @click="closeDialog" src="@/assets/img/modal_close_icn.svg" />
    </div>

    <perfect-scrollbar class="body-scrollbar" ref="scrollBar">
      <div v-if="notif" class="notif">{{ notif }}</div>
      <div v-if="title" class="title">{{ title }}</div>
      <div v-if="subtitle" class="subtitle">{{ subtitle }}</div>
      <slot name="body"></slot>
    </perfect-scrollbar>

    <span class="dialog-footer">
      <slot name="footer"><div class="btn-ok" @click="closeDialog">OK</div></slot>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    notif: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateScrollbar);
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog', true);
    },

    handleBeforeClose() {
      if (this.closeOnClickModal) {
        this.closeDialog();
      }
    },

    updateScrollbar() {
      if (this.$refs.scrollBar) {
        this.$refs.scrollBar.update();
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollbar);
  }
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  overflow: hidden;
  ::v-deep .base-dialog {
    min-width: 500px;
    border-radius: 8px;
    @media screen and (max-width: 959px) {
      width: calc(100vw - 36px) !important;
      min-width: 320px;
    }
    @media screen and (max-width: 959px) and (max-device-width: 959px) and (orientation: landscape) {
      margin-top: 20px !important;
    }
    .el-dialog__header {
      border-radius: 8px;
      display: flex;
      height: auto;
      max-height: 56px;
      padding: 1.3vh 1.3vh 1.3vh 0;
      padding-right: 1.041% !important;
      justify-content: flex-end;
      align-items: center;
    }
    .el-dialog__body {
      padding: 0px !important;
      line-height: normal;
      color: #303133;
      .body-scrollbar {
        padding-top: 0px;
        padding-left: clamp(24px, 4.167%, 40px);
        padding-right: clamp(24px, 4.167%, 40px);
        max-height: 520px;
        min-height: 120px;
        box-sizing: border-box;
        @media screen and (max-width: 959px) and (max-device-width: 959px) and (orientation: landscape) {
          max-height: calc(100vh - 186px) !important;
        }
      }
      .notif {
        background-color: #ebeef1;
        display: flex;
        padding: 12px 24px;
        justify-content: center;
        align-items: center;
        margin-bottom: 40px;
        border-radius: 5px;
        font-size: 16px;
        line-height: 16px;
        font-weight: 500 !important;
        &::first-letter {
          text-transform: uppercase;
        }
        @media screen and (max-width: 959px) {
          padding: 12px 24px;
          font-size: 14px;
        }
      }
      .title {
        color: #0087d2;
        font-size: 20px;
        font-weight: 700;
        line-height: 100%;
        text-align: center;
      }
      .subtitle {
        margin-top: 16px;
        color: #141821;
        font-size: 12px;
        font-weight: 500;
        line-height: 12px;
        text-align: center;
        white-space: pre;
        @media screen and (max-width: 959px) {
          line-height: 18px;
        }
      }
    }
  }
  &.full-screen {
    ::v-deep .base-dialog {
      @media screen and (max-width: 498px),
      (max-width: 959px) and (max-device-width: 959px) and (orientation: landscape) {
        border-radius: 0px;
        margin-top: 0px !important;
        width: 100vw !important;
        height: 100svh;
        height: 100dvh;

        .dialog-header span {
          display: none;
        }
        .body-scrollbar {
          padding: 0px 16px !important;
          height: calc(100dvh - 128px) !important;
          max-height: calc(100dvh - 128px) !important;
        }
        .notif {
          width: 100vw;
          border-radius: 0px !important;
          margin-left: -16px;
        }
      }
    }
  }
}
.dialog-header {
  display: flex;
  font-size: 16px;
  align-items: center;
  .btn-close {
    margin-left: 4px;
    width: 36px;
    cursor: pointer;
    @media screen and (max-width: 959px) {
      width: 32px;
    }
  }
  span {
    color: #0087d2;
    font-size: 10px;
  }
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px 32px;
  padding: 2.5vh 2vh 4vh;
  box-sizing: border-box;
  @media screen and (max-width: 959px) and (max-device-width: 959px) and (orientation: landscape) {
    padding: 0px;
    bottom: 0;
    height: 80px;
  }
  @media screen and (max-width: 498px) {
    bottom: 0px;
    height: 80px;
  }
  .btn-ok {
    display: flex;
    border-radius: 8px;
    background: #0087d2;
    width: 240px;
    max-width: 382px;
    padding: 16px 0px;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
  }
}
</style>
